import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  multiListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('videos', {
  plugins: [
    allListPlugin,
    multiListPlugin,
    customListPlugin,
    includedResources,
  ],
});
